<template>
  <div class="kuni-wrapper" @click="$emit('click')">
    <b-button class="btn-kuni">
      <div v-if="symbol"><img :src="srcIcon" />{{ symbol }}</div>
      <div v-else>
        <b-skeleton width="70px" height="32px" type="text"></b-skeleton>
      </div>
      <div class="reward-number" v-if="!isLoading && isConnected">
        {{ utils.bigToCommon(balance, 18, 2) }}
      </div>
      <div v-else>
        <b-skeleton
          v-if="isConnected"
          width="70px"
          height="32px"
          type="text"
        ></b-skeleton>
      </div>
    </b-button>
  </div>
</template>

<script>
export default {
  props: ["symbol", "srcIcon", "isLoading", "isConnected", "balance"],
};
</script>
<style lang="scss">
.kuni-wrapper {
  .btn-kuni {
    border: none;
    border-radius: 2px;
    background: linear-gradient(
      180deg,
      rgba(70, 50, 100, 0) 0%,
      rgba(235, 52, 95, 0.6) 100%
    );
    min-width: 260px;
    min-height: 48px;
    display: flex;
    padding: 8px 20px;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    img {
      margin-right: 6px;
      width: 24px;
      height: auto;
    }
    &:active,
    &:focus {
      box-shadow: none;
    }
  }
  .reward-number {
    font-family: "Bebas Neue";
    font-size: 24px;
    line-height: 29px;
    font-weight: 400;
  }
}
@media (max-width: 767px) {
  .kuni-wrapper {
    width: 100%;
    .btn-kuni {
      width: 100%;
      min-width: 220px;
    }
  }
}
</style>
